import { Flex, Grid, GridItem } from "@chakra-ui/react";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import { RanaHeading, RanaModal } from "@nens/ranalib";

import LoadingIndicatorVisual from "../components/LoadingIndicatorVisual";
import Snackbar from "../components/Snackbar";
import StartScreenBackground from "../StartScreen/StartScreenBackground";
import { attemptLogin } from "../state/session";

import heightWidthStyles from "./../styles/HeightWidth.module.css";

interface AttemptLoginProps {
  attemptLogin: () => void;
}

// This component checks if we are logged in; if yes, set that in the Redux state;
// if no, redirect to the login page. It should only be shown briefly when the app
// starts up.
const AttemptLoginComponent = (props: AttemptLoginProps) => {
  const { attemptLogin } = props;
  useEffect(() => {
    attemptLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={heightWidthStyles.Full}>
      <StartScreenBackground>
        <Snackbar />
        <RanaModal
          isOpen={true}
          bodyPx={2}
          width="800px"
          bgGradient="linear(to-r, #fff 0%, #b7d1e4 100%)"
        >
          <Grid gap={8} pb={12} px={12} templateColumns="repeat(2, 1fr)">
            <GridItem w={350}>
              <RanaHeading type="h3">
                <FormattedMessage
                  id="authentication.waiting"
                  defaultMessage="Waiting for authentication..."
                />
              </RanaHeading>
            </GridItem>
            <GridItem w={300}>
              <Flex w="full" h="full" alignItems="center" justifyContent="center">
                <LoadingIndicatorVisual />
              </Flex>
            </GridItem>
          </Grid>
        </RanaModal>
      </StartScreenBackground>
    </div>
  );
};

export const AttemptLogin = connect(null, {
  attemptLogin,
})(AttemptLoginComponent);
